import React from 'react';

interface TooltipSettings {
  enabled: boolean;
}

interface TooltipContextValue extends TooltipSettings {
  setEnabled: (v: boolean) => void;
}

const TooltipContext = React.createContext<TooltipContextValue | undefined>(undefined);

const STORAGE_KEY = 'yatzy-tooltips-enabled';

export const TooltipProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [enabled, setEnabledState] = React.useState<boolean>(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw === null) return true; // default on
      return raw === '1';
    } catch { return true; }
  });

  const setEnabled = (v: boolean) => {
    setEnabledState(v);
    try { localStorage.setItem(STORAGE_KEY, v ? '1':'0'); } catch {}
  };

  return (
    <TooltipContext.Provider value={{ enabled, setEnabled }}>
      {children}
    </TooltipContext.Provider>
  );
};

export function useTooltips() {
  const ctx = React.useContext(TooltipContext);
  if (!ctx) throw new Error('useTooltips must be used within TooltipProvider');
  return ctx;
}
